import * as actions_stock_parts from 'actions/stock-parts-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect } from 'react';
import { Avatar, CloseX, Spinner } from 'enspire-manager-framework';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { DashboardDetail } from 'components/common/dashboard-detail';

const _ = require('lodash');

const StockPartDashboard = (props) => {

	const dispatch = useDispatch();
	const history = useHistory();
	const params = useParams();
	const routerLocation = useLocation();
	const stockParts = useSelector((store) => store.stockParts);
	const vendors = useSelector((store) => store.profiles.vendors);
	const partsCategories = useSelector((store) => store.settings.settings_parts_categories);

	useEffect(() => {
		if (parseInt(params.stock_part_id)) dispatch(actions_stock_parts.subStockPart(params.handle, params.stock_part_id));
		return () => {
			let unsubscribe = stockParts.stock_part_selected_unsubscribe;
			if (typeof unsubscribe === "function") unsubscribe();
		};

	}, [params.stock_part_id]);

	//Functions
	const openForm = () => {
		let segments = (props.source == 'assets' || props.source == 'vendors') ? 9 : 5;
		let location = toolbox.modifyPath(routerLocation.pathname, segments, "stock-part-form/" + params.stock_part_id);
		history.push({ pathname: location });
	};

	const stockPart = stockParts.stock_part_selected;

	const categories = stockPart?.categoryIds?.map((categoryId) => {
		let name = _.find(partsCategories, (c) => c.id == categoryId)?.name;
		return (
			<span key={ categoryId } className="badge">{ toolbox.toProperCase(name) }</span>
		);
	}); 

	const primaryVendor = (stockPart?.primaryVendorId) ? _.find(vendors, { id: stockPart.primaryVendorId })?.displayName : null;
	const secondaryVendor = (stockPart?.secondaryVendorId) ? _.find(vendors, { id: stockPart.secondaryVendorId })?.displayName : null;

	return (
		<div className="row m-t-lg mb-2">
			{stockPart && parseInt(params.stock_part_id) ? (
				<>
					<div id="asset-avatar" className="col-11">
						<div className="profile-image">
							<Avatar
								className="mx-auto"
								color="white"
								bgColor="saddleBrown"
								size={90}
								name={stockPart.name}
								// image={}
								border="4px solid white"
							/>
						</div>
						<div className="profile-info">
							<h1>{stockPart.name}</h1>
							<button
								className="btn btn-default btn-sm position-absolute"
								style={{ right: "12px", zIndex: 10 }}
								type="button"
								onClick={() => openForm()}
							>
								Edit Stock Part
							</button>
							<h4>{categories}</h4>
						</div>
						{stockPart.deleted && (
							<button type="button" className="btn btn-outline btn-danger" >
								ARCHIVED
							</button>
						)}
					</div>
					<div className="col-1" />
					<div className="col-12">
						<div id="stockPart-details" className="mt-3 mb-3" style={{ width: '95%' }}>
							<DashboardDetail field={ 'Id' } value={ stockPart.id } />
							<DashboardDetail field={ 'Part #' } value={ stockPart.partNumber } />
							<DashboardDetail field={ 'Manufacturer' } value={ stockPart.manufacturer } />
							<DashboardDetail field={ 'Primary Vendor' } value={ primaryVendor } 
								link={ `#/${params.handle}/vendors/vendor/${stockPart.primaryVendorId}/form/0/stock_parts` } />
							<DashboardDetail field={ 'Alt Vendor' } value={ secondaryVendor }
								link={ `#/${params.handle}/vendors/vendor/${stockPart.secondaryVendorId}/form/0/stock_parts` } />
							<DashboardDetail field={ 'Description' } value={ stockPart.description } />
						</div>
					</div>
				</>
			) : stockParts.stock_part_selected_pending ? (
				<Spinner center />
			) : (
				<div className="col-12">
					<h2 className="text-center mb-4">Asset Unavailable</h2>
				</div>
			)}
		</div>
	);
};

export default StockPartDashboard;
